// France
import {ParticularConditionTypeEnum} from "../../../core/_models/documents/particular.condition.type.enum";

export const locale = {
    lang: 'fr',
    data: {
        TRANSLATOR: {
            SELECT: 'choisissez votre langue',
        },
        OPPORTUNITIES_LIST: {
            HEADER: 'Opportunités gagnées',
            ERROR: {
                COLLECT_DATA: 'Désolé! Nous avons rencontré un problème de collection de donnèes'
            },
            TABLE: {
                LABEL: {
                    NO_ELEMENT: 'Aucune opportunité gagnée',
                    CUSTOMER: 'Client',
                    OPPORTUNITY: 'Opportunité',
                    AMOUNT: 'Montant'
                },
                BUTTON: {
                    DETAILS: 'Détails',
                    NOT_IDENTIFIED: 'Client non reconnu'
                }
            },
            ALERT_DIALOG: {
                MESSAGE: 'Le client n\'est pas reconnu correctement du MDM. Le Siret, la raison sociale ou l\'adresse ne permet pas une identification claire.\n' +
                    '\n' +
                    'Il n\'est pas possible de poursuivre la saisie automatique pour le moment',
                TITLE: 'Problème MDM - Compte client non reconnu'
            },
            INFORMATION: 'Information concernant la qualité des données client.',
            ClIENT_NOT_IDENTIFIED: 'Client non reconnu:',
            INFORMATION_DETAILS_BEFORE: 'Vérifier les informations client dans Galaxie à l\'aide de DataQuality (action ASC). Une fois la correction faite dans Galaxie cliquer sur le bouton actualiser',
            INFORMATION_DETAILS_AFTER: 'pour saisir le contrat.',
            FILTER: {
                CONTRACT_TO_ENTER: 'A saisir',
                WAITING_FOR_ENTRY: 'En attente de saisie',
                TO_ENTER_AND_DRAFT: 'A saisir / Brouillon',
                REQUIRED_ACTION: 'Action requise',
                AWAITING_CUSTOMER_SIGNATURE: 'En attente de signature client',
                SIGNED_CUSTOMER: 'Signé client',
                INVALID: 'Invalidé',
                REFUSE: 'Refusé',
                REFUSE_AND_INVALID_AND_ABANDON: 'Invalidé',
                ALL: 'Tout'
            },
            PLACEHOLDER:{
                FILTER_BY_CLIENT:'Recherche client'
            },
            WARNING_MESSAGE: {
                UNRECOGNIZED_CUSTOMER: {
                    TITLE: 'Client non reconnu',
                    TEXT_DISCO: 'Rechercher en cliquant sur le nom ou SIRET du client, comparer et mettre à jour la fiche client Galaxie avec le SIRET, raison sociale & l\'adresse et appuyer sur le bouton d\'actualisation',
                    TEXT_AC: 'Rechercher en cliquant sur le nom ou SIRET du client, comparer et mettre à jour la fiche client TARGET avec le SIRET, raison sociale & l\'adresse et appuyer sur le bouton d\'actualisation'
                }
            },
            MODAL: {
                NEW_CUSTOMER: {
                    LABEL:'Client non reconnu',
                    MESSAGE_PREFIX:'Vous pouvez faire un contrat avec une entreprise immatriculée récemment disposant du SIRET définitif et dont les informations sont disponibles dans l\'annuaire des entreprises : ',
                    MESSAGE_LINK:'https://annuaire-entreprises.data.gouv.fr',
                    MESSAGE_SUFFIX:'En confirmant vous vous engagez à utiliser les informations de l\'annuaire des entreprises : raison sociale et adresse correspondant au SIRET',
                    BUTTON: {
                        CONTINUE: 'CONTINUER',
                        CANCEL: 'ANNULER'
                    }
                }
            }
        },
        OPPORTUNITY_DETAILS: {
            HEADER: 'Opportunité',
            TABLE: {
                LABEL: {
                    CONTRACT_TYPE: 'Type contrat',
                    AMOUNT: 'Montant',
                    STATUS: 'Statut'
                },
                BUTTON: {
                    START: 'Saisir',
                    CONTINUE: 'Poursuivre',
                    VIEW: 'Consulter',
                    UNAVAILABILITY: 'Saisie non disponible pour le moment',
                    CORRECT: 'Corriger',
                    RESENT: 'Renvoyer',
                    INVALIDATE: 'Invalider',
                    OTHER_ACTIONS: 'Autres actions',
                    CANCEL: 'Abandonner'
                }
            },
            ENUM: {
                CONTRACT_STATUS: {
                    CONTRACT_DRAFT: 'Brouillon',
                    CONTRACT_IN_PROGRESS: 'Envoi en cours',
                    CONTRACT_SENT: 'Action requise',
                    CONTRACT_ERROR: 'Echec d\'envoi',
                    CONTRACT_DELIVERED: 'Consulté par le client',
                    CONTRACT_COMPLETED: 'Signé client',
                    CONTRACT_DECLINED: 'Refusé',
                    CONTRACT_VOIDED: 'Invalidé',
                    CONTRACT_RESENT: 'Renvoyé au client',
                    CONTRACT_ABANDONED: 'Abandonné',
                    RECIPIENT_SENT: 'Envoyé au client',
                    RECIPIENT_RESENT: 'Renvoyé au client',
                    RECIPIENT_REASSIGN: 'Réattribué par le client',
                    RECIPIENT_AUTO_RESPONDED: 'Echec (erreur email)'
                }
            },
            MESSAGE: {
                RESENT: {
                    SUCCESS: 'Contrat renvoyé avec succès'
                }
            },
            MODAL: {
                INVALIDATE_CONTRACT: {
                    LABEL:'Motif de l\'invalidation de l\'enveloppe',
                    REASON: {
                        NECESSARY_CHANGE : 'Création d\'un nouveau contrat - changement d\'informations client: adresse e-mail, modification commentaire, infos de livraison, horaires d\'ouverture...',
                        NECESSARY_CHANGE_CREATE_NEW_OPP : 'Création d\'un nouveau contrat - changement de prestation: articles, prix',
                        PAPER_SIGNATURE : 'Signature papier',
                        CUSTOMER_DOES_NOT_SIGN : 'Le client ne souhaite pas signer',
                        OTHER : 'Autre'
                    },
                    PLACEHOLDER:'Précisez la raison de l’invalidation',
                    BUTTON: {
                        INVALIDATE: 'INVALIDER',
                        CANCEL: 'ANNULER'
                    },
                    MESSAGE:{
                        SUCCESS: 'Contrat invalidé avec succès'
                    }
                },
                CANCEL_CONTRACT: {
                    LABEL: 'Motif d’abandon de la saisie',
                    PLACEHOLDER: 'Précisez le motif d\'abandon de la saisie',
                    BUTTON: {
                        CANCELLATION: 'VALIDER',
                        CANCEL: 'ANNULER'
                    },
                    MESSAGE:{
                        SUCCESS: 'Saisie abandonnée avec succès'
                    }
                },
                COPY_CONTRACT: {
                    MESSAGE:{
                        SUCCESS: 'Contrat copié avec succès'
                    }
                }

            }
        },
        CONTRACT: {

            WIZARD: {
                HEADER: {
                    CONTRACT_AMENDMENT: 'Contrat/Avenant',
                    CUSTOMER_INFO: 'Infos client',
                    BILLING_INFO: 'Infos facturation',
                    DELIVERY_INFO: 'Infos livraison',
                    DOCUMENTS: 'Documents',
                    RECIPIENTS: 'Destinataires'
                },
                BUTTON: {
                    PREVIOUS: 'Précédent',
                    NEXT: 'Suivant',
                    FINISH_LATER: 'Terminer ultérieurement',
                    SEND: 'Envoyer',
                    CLOSE: 'Fermer'
                },
                MESSAGE: {
                    SAVED_CONTRACT: 'Votre contrat a bien été enregistré'
                }
            },
            CUSTOMER_INFO: {
                HEADER: 'Information client',
                LABEL: {
                    LEGAL_FORM: 'Forme Juridique',
                    CUSTOMER_NAME: 'Nom client',
                    CUSTOMER_NATIONAL_ID: 'SIRET',
                    CUSTOMER_NATIONAL_ID_IN_PROGRESS: 'SIRET en cours d’attribution',
                    COMMERCIAL_NAME: 'Nom commercial',
                    SIGN: 'Enseigne',
                    NAF_CODE: 'Activité professionnelle',
                    ADDRESS3: 'Bâtiment / Immeuble',
                    ADDRESS1: 'Numéro / Voie',
                    ADDRESS2: 'Complément',
                    POST_CODE: 'Code postal',
                    CITY: 'Ville',
                    COUNTRY_ADRESS: 'Pays',
                    PHONE_NUMBER: 'Téléphone',
                    MAIL: 'Adresse email',
                    TYPE1: 'Exploitation directe / Location gérance',
                    TYPE2: 'Franchisé/ Concessionnaire',
                    CLIENT: 'CLIENT',
                    PROSPECT: 'PROSPECT'
                },
                HINT: {
                    LEGAL_FORM: 'S’il s’agit d’un artisan, choisir Entrepreneur individuel.',
                    CUSTOMER_NAME: 'Selon la forme juridique : Raison sociale ou Civilité Nom Prénom',
                    PHONE_NUMBER: 'Téléphone fixe à défaut téléphone portable',
                },
                ENUM: {
                    LEGAL_FORM: {
                        FREELANCE: 'Entrepreneur individuel',
                        COMPANY: 'Société'
                    },
                    TYPE1: {
                        DIRECT_OPERATION: 'Exploitation directe',
                        LEASE_MANAGEMENT: 'Location gérance'
                    },
                    TYPE2: {
                        FRANCHISE: 'Franchise',
                        DEALER: 'Concessionnaire'
                    }
                },
                VALIDATORS: {
                    LEGAL_FORM: {
                        REQUIRED: 'Veuillez choisir une forme juridique'
                    },
                    CUSTOMER_NAME: {
                        REQUIRED: 'Veuillez renseigner un nom client'
                    },
                    CUSTOMER_NATIONAL_ID: {
                        REQUIRED: 'Veuillez renseigner un Siret'
                    },
                    NAF_CODE: {
                        REQUIRED: 'Veuillez sélectionner une activité professionnelle'
                    },
                    ADDRESS1: {
                        REQUIRED: 'Veuillez renseigner une adresse'
                    },
                    POST_CODE: {
                        REQUIRED: 'Veuillez renseigner un code postal',
                        VALID: 'Le code postal doit faire 5 chiffres'
                    },
                    CITY: {
                        REQUIRED: 'Veuillez renseigner une ville'
                    },
                    COUNTRY_ADRESS: {
                        REQUIRED: 'Veuillez sélectionner un pays'
                    },
                    PHONE_NUMBER: {
                        REQUIRED: 'Veuillez renseigner un téléphone',
                        VALID: 'Le numéro de teléphone renseigné n\'est pas valide'
                    },
                    MAIL: {
                        REQUIRED: 'Veuillez renseigner une adresse mail',
                        VALID: 'L\'adresse email renseignée n\'est pas valide'
                    },
                    BUSINESS_NAME: {
                        REQUIRED: 'Veuillez renseigner la raison sociale',
                    },

                }
            },
            DELIVERY_INFO: {
                LABEL: {
                    PDL_CODE: 'Code PDL',
                    CLOSING_DAYS: 'Jours de fermeture',
                    OPENING_HOURS: 'Horaires d\'ouverture',
                    ACCESS_INFO: 'Autres infos accès',
                    DELIVERY_ADDRESS_TYPE: 'Lieu de livraison',
                    PEST_CONTROL_CONTACT_PERSON: {
                        TITLE: 'Interlocuteur Pest Control',
                        FIRSTNAME: 'Prénom',
                        LASTNAME: 'Nom',
                        MAIL: 'Email',
                    }
                },
                DELIVERY_TIME_TYPE: {
                    WITH_INTERRUPTION: 'avec interruption',
                    WITHOUT_INTERRUPTION: 'sans interruption',
                },
                DELIVERY_ADDRESS_TYPE: {
                    CUSTOMER: 'Adresse client',
                    OTHER: 'Autre adresse',
                    MULTIPLE: 'Plusieurs adresses'
                },
                MESSAGE: {
                    MULTIPLE_ADDRESSES: 'Passez directement à l\'étape 5 et ajoutez autant d\'exemplaires que nécessaire pour les formulaires. Les adresses seront à saisie libre dans DocuSign',
                    INCORRECT_TIME: 'L\'heure de fermeture doit être postérieure à l\'heure d\'ouverture',
                    INCORRECT_PERIOD: 'La deuxième période doit être postérieure à la première'
                }
            },
            BILLING_INFO: {
                LABEL: {
                    ANOTHER_BILLING_ADDRESS: 'Autre adresse pour l\'envoi de la facture',
                    BILLING_ADDRESS_TYPE: 'Facturation: Conditions et adresse',
                    PAYMENT_TERMS: 'Conditions de règlement',
                    PAYMENT_METHOD: 'Mode de paiement',
                    ELECTRONIC_INVOICE_EMAIL: 'Email facture électronique originale',
                    COURIER_BILLING: 'Facture par courrier',
                    CUSTOMER_NATIONAL_ID: 'SIRET',
                    BUSINESS_NAME: ' Raison sociale',
                    RECIPIENT_SERVICE: 'Service destinataire',
                    ADDRESS3: 'Bâtiment / Immeuble',
                    ADDRESS1: 'Numéro / Voie',
                    ADDRESS2: 'Complément',
                    POST_CODE: 'Code postal',
                    CITY: 'Ville',
                    PHONE: ' Téléphone'
                },
                MESSAGE: {
                    PAYER_FORM_TITLE: 'Nom et adresse du Payeur',
                    BILLING_FORM_TITLE: 'Nom et adresse pour l\'envoi de la facture'
                }
            },
            ADDRESS: {
                ADDRESS_LINE1: 'Numéro / Voie',
                ADDRESS_LINE2: 'Complément',
                ADDRESS_LINE3: 'Bâtiment / Immeuble',
                POST_CODE: 'Code postal',
                CITY: 'Ville',
                PHONE_NUMBER: 'Téléphone'
            },
            DOCUMENTS: {
                LABEL: {
                    DOCUMENTS_TO_SEND: 'Documents à envoyer',
                    NUMBER: 'Nombre',
                    DOCUMENT: 'Document',
                    MORE_DOCS: 'Autres documents',
                    ANNEX: 'Modèles DocuSign',
                    ALERT_MESSAGE: 'Il peut être nécessaire d\'ajuster la quantité d\'exemplaires pour les conditions particulières selon le nombre d\'articles et/ou PDL au contrat',
                    ALERT_MESSAGE_TITLE: 'Attention'
                },
                ENUM: {
                    PARTICULAR_CONDITION_TYPE: {
                        AUTO: 'PDF auto non modifiable ',
                        MANUAL: 'Modèle DocuSign à saisie libre',
                    }
                },
                ANNEX_DOCUMENT: {
                    LABEL: {
                        TITLE: 'Sélectionner des modèles',
                        COMMENT: 'Mandat prélèvement SEPA, Etude faisabilité fontaine réseau, Etude des besoins EPI, Prise de taille VT'
                    },
                    BUTTON: {
                        ADD_ANNEX: 'Ajouter La sélection',
                        CANCEL: 'Annuler'
                    }
                },
                STATIC_DOCUMENT: {
                    LABEL: {
                        TITLE: 'Sélectionner des modèles'
                    },
                    BUTTON: {
                        CHOOSE: 'Choisir des fichiers',
                        ADD: 'Ajouter',
                        CANCEL: 'Annuler'
                    },
                    VALIDATORS: {
                        FILE_SIZE: 'La taille totale des fichiers ne doit pas dépasser 5 Mo',
                        FILE_TYPE: 'Les fichiers autorisés doivent être des PDF, Excel, Word ou des images (JPG, JPEG ou PNG)',
                        SAME_FILE: 'Un document portant le même nom a déjà été ajouté'
                    }
                }
            },
            CONTRACT_AMENDMENT: {
                LABEL: {
                    CONTRACT: 'Contrat',
                    AMENDMENT: 'Avenant',
                    SECURITY_DEPOSIT: 'Dépôt de garantie',
                    FREQUENCY: 'Fréquence de service / passage',
                    BILLING_FREQUENCY: 'Fréquence de facturation',
                    MINIMUM_BILLING: 'Minimum de facturation (à la piece)',
                    WEEKLY: 'Hebdomadaire',
                    MONTHLY: 'Mensuel',
                    INITIAL_SETUP_COSTS: 'Frais de 1ère mise en place',
                    QUANTITY: 'Quantité',
                    UNIT_PRICE: 'Prix Unitaire € HT',
                    TOTAL_PRICE: 'Total € HT',
                    PEST_CONTROL_RODENT: 'Pest Control - Rongeur',
                    PEST_CONTROL_RODENT_TOTAL: 'TOTAL HT \n Remise à niveau',
                    PEST_CONTROL_RODENT_UNIT_PRICE: 'P.U.HT.Extra'
                },
                ENUM: {
                    SECURITY_DEPOSIT_MODE_TYPE: {
                        CASH: 'Espèces',
                        CHECK: 'Chèque',
                        BANK_TRANSFER: 'virement bancaire',
                        NOTHING: 'Aucun'
                    },
                    FREQUENCY: {
                        H: 'Hebdomadaire',
                        Q: 'Quatorzaine',
                        M: 'Mensuel',
                        E: 'Sesquimestriel',
                        B: 'Bimestriel',
                        T: 'Trimestriel',
                        K: 'Quadrimestriel',
                        S: 'Semestriel',
                        A: 'Annuel',
                        NONE: 'Aucune',
                        NOTHING: 'Aucune'
                    },
                    PASSING_FREQUENCY: {
                        D1: '1j/semaine',
                        D2: '2j/semaine',
                        D3: '3j/semaine',
                        D4: '4j/semaine',
                        D5: '5j/semaine',
                        D6: '6j/semaine',
                        D7: '7j/semaine',
                    },
                    QUALIFICATION: {
                        RENEGOTIATION: 'Renégociation & Vente additionnelle',
                        ADDITIONAL: 'Vente additionnelle uniquement'
                    },
                    SERVICE: {
                        PC: 'Lutte contre les nuisibles',
                        BEV: 'Boisson-Service',
                        WIP: 'Essuyage industriel',
                        WE: 'Habillement-Service',
                        LIN: 'Linge-Service',
                        WR: 'Sanitaire-Service',
                        MAT: 'Sol-Service',
                        PIMW: 'DASRI',
                    }

                },
                NOT_AUTOMATED_MESSAGE: 'Saisie manuelle DocuSign',
                AUTOMATED_INFORMATION: ' Le contrat reprendra les informations (articles et prix) inclus au service sur Pricing.',

            },
            RECIPIENTS: {
                LABEL: {
                    FIRSTNAME: 'Prénom',
                    LASTNAME: 'Nom',
                    EMAIL: 'Email',
                    FUNCTION: 'Fonction',
                    EMAIL_SIGNATURE: 'Signature par email',
                    PERSON_SIGNATURE: 'Signature en personne',
                    EMAIL_SUBJECT: 'Objet de l\'email',
                    EMAIL_MESSAGE: 'Message électronique',
                    RECIPIENT: 'Destinataire',
                },
                SUB_TITLE: {
                    RECIPIENTSCC: 'Vous pouvez ajouter jusqu\'à deux destinataires recevant une copie du contrat signé',
                },
                TITLE: {
                    CUSTOMER: 'Client',
                    RECIPIENTS: 'Destinataires',
                    RECIPIENTSCC: 'Destinataires en copie',
                    OTHER_SIGNATORY: 'Précisez l\'hôte pour la signature client (commercial, Agent de service...)',
                    MESSAGE: 'Message'
                },
                CONTENT: {
                    EMAIL_SUBJECT: 'Elis - {{contractAmendmentType}} {{contractType}} {{customerName}}',
                    EMAIL_MESSAGE_CONTRACT: 'Bonjour,  \n' +
                        '\n' +
                        'Voici le lien permettant d\'accéder au contrat. \n' +
                        'Je vous invite à le vérifier puis à le signer.\n' +
                        'Restant disponible.\n' +
                        'Respectueusement, ',
                    EMAIL_MESSAGE_AMENDMENT: 'Bonjour,  \n' +
                        '\n' +
                        'Voici le lien permettant d\'accéder à l\'avenant. \n' +
                        'Je vous invite à le vérifier puis à le signer.\n' +
                        'Restant disponible.\n' +
                        'Respectueusement, '
                },
                DIALOG: {
                    MESSAGE: 'Votre contrat est en cours de création, ' +
                        'Vous recevrez le mail de signature bientôt'
                },
                FUNCTION: {
                    DCG: 'Directeur commercial',
                    DCP: 'Directeur commercial',
                    DR: 'Directeur régional',
                    DCR: 'Directeur commercial régional',
                    DC: 'Directeur de centre',
                    CC: 'Chef de centre',
                    CSC: 'Chef de service client',
                    CCL: 'Chargé de clientèle',
                    ASC: 'Assistante de service client',
                    ADV: 'Assistante des ventes',
                    CRV: 'Chef régional des ventes',
                    AC: 'Attaché commercial'
                },
                VALIDATOR: {
                    EMAIL: 'L\'adresse email renseignée n\'est pas valide',
                    EMAIL_ELIS: 'Veuillez saisir une adresse mail ELIS'
                }
            }
        },
        MENU: {
            NEW: 'Nouveau',
            ACTIONS: 'Actes',
            CREATE_POST: 'Créer un nouveau Post',
            PAGES: 'Pages',
            FEATURES: 'Fonctionnalités',
            APPS: 'Applications',
            DASHBOARD: 'Tableau de Bord',
        },
        AUTH: {
            GENERAL: {
                OR: 'Ou',
                SUBMIT_BUTTON: 'Soumettre',
                NO_ACCOUNT: 'Ne pas avoir de compte?',
                SIGNUP_BUTTON: 'Registre',
                FORGOT_BUTTON: 'Mot de passe oublié',
                BACK_BUTTON: 'Back',
                PRIVACY: 'Privacy',
                LEGAL: 'Legal',
                CONTACT: 'Contact',
            },
            LOGIN: {
                TITLE: 'Créer un compte',
                BUTTON: 'Sign In',
            },
            FORGOT: {
                TITLE: 'Forgotten Password?',
                DESC: 'Enter your email to reset your password',
                SUCCESS: 'Your account has been successfully reset.'
            },
            REGISTER: {
                TITLE: 'Sign Up',
                DESC: 'Enter your details to create your account',
                SUCCESS: 'Your account has been successfuly registered.'
            },
            INPUT: {
                EMAIL: 'Email',
                FULLNAME: 'Fullname',
                PASSWORD: 'Mot de passe',
                CONFIRM_PASSWORD: 'Confirm Password',
                USERNAME: 'Nom d\'utilisateur'
            },
            VALIDATION: {
                INVALID: '{{name}} n\'est pas valide',
                REQUIRED: '{{name}} est requis',
                MIN_LENGTH: '{{name}} minimum length is {{min}}',
                AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
                NOT_FOUND: 'The requested {{name}} is not found',
                INVALID_LOGIN: 'The login detail is incorrect',
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_FIELD: 'Field is not valid',
            }
        },
        ECOMMERCE: {
            COMMON: {
                SELECTED_RECORDS_COUNT: 'Nombre d\'enregistrements sélectionnés: ',
                ALL: 'All',
                SUSPENDED: 'Suspended',
                ACTIVE: 'Active',
                FILTER: 'Filter',
                BY_STATUS: 'by Status',
                BY_TYPE: 'by Type',
                BUSINESS: 'Business',
                INDIVIDUAL: 'Individual',
                SEARCH: 'Search',
                IN_ALL_FIELDS: 'in all fields'
            },
            ECOMMERCE: 'éCommerce',
            CUSTOMERS: {
                CUSTOMERS: 'Les clients',
                CUSTOMERS_LIST: 'Liste des clients',
                NEW_CUSTOMER: 'Nouveau client',
                DELETE_CUSTOMER_SIMPLE: {
                    TITLE: 'Suppression du client',
                    DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement ce client?',
                    WAIT_DESCRIPTION: 'Le client est en train de supprimer ...',
                    MESSAGE: 'Le client a été supprimé'
                },
                DELETE_CUSTOMER_MULTY: {
                    TITLE: 'Supprimer les clients',
                    DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement les clients sélectionnés?',
                    WAIT_DESCRIPTION: 'Les clients suppriment ...',
                    MESSAGE: 'Les clients sélectionnés ont été supprimés'
                },
                UPDATE_STATUS: {
                    TITLE: 'Le statut a été mis à jour pour les clients sélectionnés',
                    MESSAGE: 'Le statut des clients sélectionnés a été mis à jour avec succès'
                },
                EDIT: {
                    UPDATE_MESSAGE: 'Le client a été mis à jour',
                    ADD_MESSAGE: 'Le client a été créé'
                }
            }
        },
        INFO_BANNER: {
            DETAILS : 'En savoir plus'
        }
    }
};
